import React, { createContext, useContext, useMemo } from "react";

import apiInstance from "../services/api";

const ApiContext = createContext({});

export const useApi = () => useContext(ApiContext);

// eslint-disable-next-line react/prop-types
function ApiProvider({ children, apiClient }) {
  const memoizedApi = useMemo(() => apiClient || apiInstance, []);

  return (
    <ApiContext.Provider value={memoizedApi}>{children}</ApiContext.Provider>
  );
}

export default ApiProvider;
